import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Snackbar,
  Grid,
  Paper,
  TableCell,
  TableRow,
  TableHead,
  Table,
  TableContainer,
  TableBody,
} from "@mui/material";

const ErrorText = ({ error, fieldLabel }) =>
  error ? (
    <Typography color="error" sx={{ fontSize: "12px", marginTop: "5px" }}>
      {fieldLabel ? `${fieldLabel}: ${error}` : error}
    </Typography>
  ) : null;

const CustomTable = ({
  label,
  fields,
  formData,
  handleInputChange,
  placeholder,
  errors,
  isOtherRow = false,
  dynamicLabel,
  handleDynamicLabelChange,
  disabled,
  labelCellSx,
  errorKeyPrefix,
  valueCellsMultiline = false,
}) => (
  <>
    <TableRow
      sx={
        valueCellsMultiline
          ? {
              "& td": { verticalAlign: "top", py: 0.5 },
            }
          : { height: "20px" }
      }
    >
      <TableCell
        sx={{
          whiteSpace: "normal",
          wordBreak: "break-word",
          verticalAlign: "top",
          ...labelCellSx,
        }}
      >
        {isOtherRow ? (
          <TextField
            disabled={disabled}
            value={dynamicLabel}
            onChange={(e) => handleDynamicLabelChange(e.target.value)}
            size="small"
            placeholder="Others-Please Specify"
            InputProps={{ disableUnderline: true }}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            }}
          />
        ) : (
          label
        )}
      </TableCell>
      {isOtherRow ? (
        <TableCell>
          <TextField
            disabled={disabled}
            name="others"
            value={formData.other?.others || ""}
            onChange={(e) =>
              handleInputChange("other", "others", e.target.value)
            }
            size="small"
            placeholder="Enter %"
            InputProps={{ disableUnderline: true }}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            }}
            error={!!errors.other?.others}
          />
          <ErrorText
            error={errors.other?.others}
            fieldLabel="Other - Please Specify"
          />
        </TableCell>
      ) : (
        fields.map((field) => (
          <TableCell
            key={field}
            sx={
              valueCellsMultiline
                ? { width: "28%", minWidth: 0, verticalAlign: "top" }
                : undefined
            }
          >
            <TextField
              disabled={disabled}
              name={field}
              value={formData[field] ?? ""}
              onChange={(e) => handleInputChange(e, field)}
              size="small"
              fullWidth
              multiline={valueCellsMultiline}
              minRows={valueCellsMultiline ? 1 : undefined}
              placeholder={placeholder}
              InputProps={{ disableUnderline: true }}
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                ...(valueCellsMultiline && {
                  "& .MuiOutlinedInput-root": {
                    overflow: "visible",
                  },
                  "& .MuiInputBase-root": {
                    alignItems: "flex-start",
                  },
                  "& .MuiInputBase-input": {
                    whiteSpace: "pre-wrap !important",
                    wordBreak: "break-all",
                    overflow: "visible !important",
                  },
                }),
              }}
              error={
                !!(
                  errorKeyPrefix
                    ? errors[`${errorKeyPrefix}.${field}`]
                    : errors[field]
                )
              }
            />
          </TableCell>
        ))
      )}
    </TableRow>
  </>
);

export default CustomTable;
